import React from "react";
const IconTiktok = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Zm11.01.606c-.433.001-.868.002-1.305.008-.01 1.396-.01 2.792-.01 4.19v2.516c-.002.262-.002.523-.001.784.001.731.002 1.461-.039 2.194-.005.204-.108.383-.209.556l-.018.033c-.323.527-.917.888-1.54.894-.933.083-1.81-.683-1.944-1.595 0-.046-.002-.093-.004-.14-.008-.255-.016-.515.082-.754a1.93 1.93 0 0 1 .756-.972c.483-.333 1.127-.383 1.677-.206 0-.352.007-.704.013-1.057.008-.47.016-.94.01-1.41-1.206-.227-2.495.156-3.417.956a4.17 4.17 0 0 0-1.433 2.756c-.011.272-.006.55.005.827.117 1.3.906 2.512 2.028 3.173a4.05 4.05 0 0 0 2.267.572c1.294-.022 2.555-.717 3.283-1.783.45-.64.705-1.412.75-2.19.01-1.01.01-2.022.01-3.036 0-.608-.001-1.216.001-1.824.289.189.583.372.9.516.728.345 1.533.511 2.333.54v-2.24c-.855-.094-1.733-.377-2.355-.994-.622-.6-.928-1.467-.972-2.317-.29.003-.578.003-.868.003Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconTiktok;
